<template>
  <a :href="'/' + store.terminologyId + '/'" :style="($vuetify.breakpoint.xsOnly) ? 'width: 100%;' : ''"
    class=" btn btn--ghost btn--default">{{ store.terminologyId }}</a>
</template>

<script>
import ConceptsStore from "../concepts-store";

export default {
  name: "TerminologyPageLink",

  data() {
    return {
      store: ConceptsStore.state,
    }
  },
}
</script>
